export default __webpack_public_path__ + "6e8f78533fc802dc69a83f86acc29a1d.png";